<template>
  <a-card>
    <a-row :gutter="16" justify="center">
      <a-col :span="24">
        <a-form-item label="메세지 수신">
          <a-switch v-model="allowMessage" @click="switchAllowMessage" />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-card style="margin-top: 0.5em;" :title="`${account.business.name} ${typeText} 예정`">
          <a-list bordered :dataSource="items">
            <a-list-item slot="renderItem" slot-scope="{name, amount}">
              {{name}}&nbsp;
              <a-badge slot="actions" :count="'×' + amount" />
            </a-list-item>
          </a-list>
        </a-card>
        <p v-if="type !== 0" style="margin-top: 0.5em;">
          <b>사유:</b>
          {{ reason || '별도의 사유를 작성하지 않으셨습니다.' }}
        </p>
      </a-col>
      <a-col :span="24" style="margin-top: 0.5em;">
        <a-textarea
          v-model="answer"
          placeholder="원활한 처리를 위해 구매 또는 교환/환불이 여부와 같은 내용을 편하게 작성하여 주세요."
        />
      </a-col>
      <a-col :span="24" style="margin-top: 0.5em">
        <a-button type="primary" icon="check" @click="onSave(true)">메모 전송</a-button>
      </a-col>
      <a-col :span="24">
        <a-collapse :activeKey="1" style="margin-top: 0.5em;">
          <a-collapse-panel header="도매 정보" key="1">
            <a-form-item label="도매 이름">
              <a-input placeholder="도매 이름" v-model="wholesale.name" />
            </a-form-item>
            <a-form-item label="전화번호">
              <a-input placeholder="핸드폰 번호" @change="getMask('phone')" v-model="wholesale.phone">
                <a-icon slot="prefix" type="customer-service" />
              </a-input>
            </a-form-item>
            <a-form-item label="핸드폰 번호">
              <a-input placeholder="핸드폰 번호" @change="getMask('mobile')" v-model="wholesale.mobile">
                <a-icon slot="prefix" type="phone" />
              </a-input>
              <p>요청 메세지는 핸드폰 번호로 발송됩니다.</p>
            </a-form-item>
            <a-button type="primary" icon="check" @click="onSave(false)">도매 정보 변경</a-button>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import config from "../../config";
import Axios from "axios";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
export default {
  name: "WholesaleRequest",
  data() {
    this.onLoad();
    return {
      allowMessage: true,
      account: {
        idx: "",
        username: "",
        phone: "",
        identity: "",
        business: {
          name: "",
          phone: ""
        }
      },
      wholesale: {
        name: "로드 중...",
        phone: "",
        mobile: ""
      },
      type: 0,
      typeText: "구매",
      answer: "",
      items: [],
      reason: ""
    };
  },
  methods: {
    async onLoad() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/request/${this.$route.params.idx}`
        );
        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.wholesale = data.wholesale;
              this.answer = data.answer;
              this.type = data.type;
              this.typeText = this.type === 0 ? "구매" : "교환 및 반납";
              this.items = data.items;
              this.reason = data.reason;
              this.allowMessage = data.allowMessage;
              this.account = data.account;
              break;
            default:
              config.alert.mixin({
                title: "오류가 발생했습니다.",
                type: "error"
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          title: "오류가 발생했습니다.",
          type: "error"
        });
      }
    },
    async onSave(isMemo) {
      try {
        const { wholesale, answer } = this;
        const form = {};

        if (isMemo) {
          form.answer = answer || "";
        } else {
          form.wholesale = wholesale;
        }

        const { data } = await Axios.post(
          `${config.hostname}/v1/request/${this.$route.params.idx}`,
          form
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              config.alert.mixin({
                title: "저장되었습니다.",
                type: "success"
              });
              break;
            default:
              config.alert.mixin({
                title: "오류가 발생했습니다.",
                type: "error"
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          title: "오류가 발생했습니다.",
          type: "error"
        });
      }
    },
    async switchAllowMessage() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/request/${this.$route.params.idx}/status?is=${this.allowMessage}`
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              config.alert.mixin({
                title: "반영되었습니다.",
                type: "success"
              });

              break;
            case OPCODE.EXISTS:
              config.alert.mixin({
                title: "오류가 발생했습니다.",
                type: "error"
              });
          }
        }
      } catch (err) {
        config.alert.mixin({
          title: "오류가 발생했습니다.",
          type: "error"
        });

        this.allowMessage = !this.allowMessage;
      }
    },
    getMask(type) {
      let num = this.wholesale[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.wholesale[type] = res;
    }
  }
};
</script>